import { ReactNode, useCallback, useState } from 'react';
import { ConnectWalletContext, ConnectWalletContextType } from './ConnectWalletContext';
import { fetchWalletConnect, fetchWalletGetMessage } from '../api/fetchApiFns';
import { useAccount, useChainId, useConnect, useDisconnect, useSignMessage, useSwitchChain } from 'wagmi';
import { CRAT_TESTNET } from '../config';

type Props = {
  children: ReactNode;
};

export const ConnectWalletProvider = ({ children }: Props) => {
  const [tokenAddress, setTokenAddress] = useState('');
  const { connectors, connectAsync } = useConnect();
  const { signMessageAsync } = useSignMessage();
  const { isConnected } = useAccount();
  const { disconnectAsync } = useDisconnect();
  const { switchChainAsync } = useSwitchChain();
  const chainId = useChainId();

  const disconnectWalletCallback = useCallback(async () => {
    disconnectAsync({ connector: connectors[0] });
  }, [connectors, disconnectAsync])

  const connectWalletCallback = useCallback(async () => {
    try {
      const msg = await fetchWalletGetMessage();
      const accounts = (await connectAsync({ connector: connectors[0] })).accounts;
      await switchChainAsync({ chainId: CRAT_TESTNET.id });
      const signResult = await signMessageAsync({ message: msg });
      if (accounts.length) {
        const tokenAddress = await fetchWalletConnect(accounts[0], signResult, msg);
        localStorage.setItem('tokenAddress', tokenAddress);
        setTokenAddress(tokenAddress);
        return tokenAddress;
      }
    } catch (error) {
      disconnectWalletCallback()
      throw error;
    }
  }, [connectAsync, connectors, switchChainAsync, signMessageAsync, disconnectWalletCallback]);

  const switchNetworkCallback = useCallback(async () => {
    try {
      if (!isConnected) await connectWalletCallback();
      if (chainId === CRAT_TESTNET.id) {
        window.alert('CratD2C Test Network has already been added to Metamask.');
      } else {
        await switchChainAsync({ chainId: CRAT_TESTNET.id });
      }
    } catch (error) {
      console.log(error);
    }
  }, [chainId, connectWalletCallback, isConnected, switchChainAsync]);

  const contextState: ConnectWalletContextType = {
    tokenAddress,
    connectWalletCallback,
    disconnectWalletCallback,
    switchNetworkCallback,
    setTokenAddress,
  };

  return <ConnectWalletContext.Provider value={contextState}>{children}</ConnectWalletContext.Provider>;
};
